import React from 'react';

import StatFigureTile from 'CommonComponents/StatFigureTile';

/**
 * Whole-project counts: they ignore the table's filters.
 */
export default function UserActivityTiles({ tiles }) {
    return (
        <div className="tw-grid tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-4">
            <StatFigureTile value={tiles?.users_on_project} label={$t('Users on project')} />
            <StatFigureTile value={tiles?.never_logged_in} label={$t('Never logged in')} attention />
            <StatFigureTile value={tiles?.logged_in_last_7_days} label={$t('Logged in last 7 days')} />
            <StatFigureTile value={tiles?.logged_in_last_30_days} label={$t('Logged in last 30 days')} />
        </div>
    );
}
